import { Link, useLocation } from 'react-router-dom';
import type { AppLocale } from '../lib/locale';
import { pathWithLocale, pathWithoutLocale } from '../lib/locale';

const LANGS: { locale: AppLocale; flag: string; title: string; hrefLang: string }[] = [
  { locale: 'en', flag: '🇺🇸', title: 'English', hrefLang: 'en' },
  { locale: 'ko', flag: '🇰🇷', title: '한국어', hrefLang: 'ko' },
  { locale: 'es', flag: '🇪🇸', title: 'Español', hrefLang: 'es' },
  { locale: 'zh', flag: '🇨🇳', title: '简体中文', hrefLang: 'zh-Hans' },
];

type LangSwitcherProps = {
  locale: AppLocale;
};

export function LangSwitcher({ locale }: LangSwitcherProps) {
  const { pathname } = useLocation();
  const rest = pathWithoutLocale(pathname);

  // Articles are English-only — no /ko/articles/* routes exist.
  // Keep the path unchanged (but ensure trailing slash) so the user stays on the same article.
  const targetFor = (loc: AppLocale) => {
    if (rest.startsWith('/articles')) return rest.endsWith('/') ? rest : `${rest}/`;
    return pathWithLocale(rest, loc);
  };

  return (
    <div className="lang-switcher">
      {LANGS.map(({ locale: loc, flag, title, hrefLang }) => (
        <Link
          key={loc}
          to={targetFor(loc)}
          title={title}
          className={`flag-link ${locale === loc ? 'active' : ''}`}
          hrefLang={hrefLang}
        >
          {flag}
        </Link>
      ))}
    </div>
  );
}
